// TallyCounter.js
import React, { useState, useEffect } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Snackbar,
  Alert,
  Button
} from '@mui/material';
const TITLE = "Penghitung Istighfar Elektronik - Penghitung Tasbih dan Istighfar - Tasbih Digital";
const DESCRIPTION = "Gunakan penghitung istighfar elektronik untuk menghitung jumlah tasbih dan istighfar dengan mudah. Penghitung digital ini memberikan cara yang nyaman untuk melacak jumlah tasbih dan istighfar dengan menekan tombol tasbih, Anda juga dapat dengan mudah mereset penghitung melalui tombol reset. Ideal untuk pengingat spiritual dan meningkatkan fokus saat beribadah.";
const KEYWORDS = "penghitung istighfar, penghitung tasbih, tasbih elektronik, penghitung istighfar online, penghitung tasbih tanpa unduh, penghitung istighfar digital";
const OG_URL = "https://do-calculate.com/calculator/id/tally-counter/";
const TallyCounter = () => {
  const [state, setState] = useState(() => {
    const savedCounts = JSON.parse(localStorage.getItem("counts")) || {};
    const savedCustom = JSON.parse(localStorage.getItem("customTasbeehat")) || [];
    const savedGoals = JSON.parse(localStorage.getItem("tasbeehGoals")) || {};
    return {
      counts: {
        astaghfirullah: savedCounts.astaghfirullah || 0,
        alhamdulillah: savedCounts.alhamdulillah || 0,
        subhanallah: savedCounts.subhanallah || 0,
        laIlahaIllallah: savedCounts.laIlahaIllallah || 0,
        allahuAkbar: savedCounts.allahuAkbar || 0,
        salawat: savedCounts.salawat || 0,
        subhanAllah: savedCounts.subhanAllah || 0,
        laIlahaIllallah2: savedCounts.laIlahaIllallah2 || 0,
        ...savedCounts
      },
      customTasbeehat: savedCustom,
      goals: savedGoals
    };
  });
  const [showModal, setShowModal] = useState(false);
  const [showGoalModal, setShowGoalModal] = useState(false);
  const [currentGoalTasbeeh, setCurrentGoalTasbeeh] = useState("");
  const [goalValue, setGoalValue] = useState("");
  const [newTasbeeh, setNewTasbeeh] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  // Function to play goal achievement sound
  const playGoalSound = () => {
    try {
      // Create audio context
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      // Create oscillator for the sound
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      // Configure the sound (celebratory beep)
      oscillator.frequency.value = 800; // Frequency in Hz
      oscillator.type = 'sine';
      // Volume envelope
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
      // Play sound
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.5);
    } catch (error) {
      console.log('Audio play failed:', error);
    }
  };
  useEffect(() => {
    localStorage.setItem("counts", JSON.stringify(state.counts));
    localStorage.setItem("customTasbeehat", JSON.stringify(state.customTasbeehat));
    localStorage.setItem("tasbeehGoals", JSON.stringify(state.goals));
  }, [state]);
  const handleIncrement = (key) => {
    setState(prev => {
      const newCount = (prev.counts[key] || 0) + 1;
      const newState = {
        ...prev,
        counts: {
          ...prev.counts,
          [key]: newCount
        }
      };
      if (prev.goals[key] && newCount >= prev.goals[key]) {
        if (newCount === prev.goals[key]) {
          playGoalSound(); // Play sound when goal is reached
          setSnackbarMessage(`Selamat! Anda telah mencapai target ${prev.goals[key]} tasbih!`);
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
        }
      }
      return newState;
    });
  };
  const handleDecrement = (key) => {
    setState(prev => ({
      ...prev,
      counts: {
        ...prev.counts,
        [key]: Math.max((prev.counts[key] || 0) - 1, 0)
      }
    }));
  };
  const handleReset = (key) => {
    setState(prev => ({
      ...prev,
      counts: {
        ...prev.counts,
        [key]: 0
      }
    }));
  };
  const handleAddTasbeeh = () => {
    if (newTasbeeh.trim() === "") return;
    const key = `custom_${Date.now()}`;
    const formattedKey = key.replace(/\s+/g, '_');
    setState(prev => ({
      ...prev,
      customTasbeehat: [...prev.customTasbeehat, { title: newTasbeeh, key: formattedKey }],
      counts: {
        ...prev.counts,
        [formattedKey]: 0
      }
    }));
    setNewTasbeeh("");
    setShowModal(false);
  };
  const handleRemoveTasbeeh = (key) => {
    setState(prev => {
      const newCounts = { ...prev.counts };
      const newGoals = { ...prev.goals };
      delete newCounts[key];
      delete newGoals[key];
      return {
        ...prev,
        customTasbeehat: prev.customTasbeehat.filter(item => item.key !== key),
        counts: newCounts,
        goals: newGoals
      };
    });
  };
  const handleRemoveGoal = (key) => {
    setState(prev => {
      const newGoals = { ...prev.goals };
      delete newGoals[key];
      return {
        ...prev,
        goals: newGoals
      };
    });
  };
  const handleSetGoal = (key) => {
    setCurrentGoalTasbeeh(key);
    setGoalValue(state.goals[key] || "");
    setShowGoalModal(true);
  };
  const handleSaveGoal = () => {
    if (!goalValue || isNaN(goalValue)) return;
    setState(prev => ({
      ...prev,
      goals: {
        ...prev.goals,
        [currentGoalTasbeeh]: parseInt(goalValue)
      }
    }));
    setShowGoalModal(false);
    setGoalValue("");
    setCurrentGoalTasbeeh("");
  };
  const defaultTasbeehat = [
    { title: "Astaghfirullah (Aku memohon ampun kepada Allah)", key: "astaghfirullah" },
    { title: "Alhamdulillah (Segala puji bagi Allah)", key: "alhamdulillah" },
    { title: "Subhanallah (Mahasuci Allah)", key: "subhanallah" },
    { title: "La ilaha illallah (Tiada Tuhan selain Allah)", key: "laIlahaIllallah" },
    { title: "Allahu Akbar (Allah Maha Besar)", key: "allahuAkbar" },
    { title: "Allahumma shalli 'ala sayyidina Muhammad (Ya Allah, limpahkanlah rahmat kepada junjungan kami Muhammad)", key: "salawat" },
    { title: "Subhanallah wa bihamdihi - Subhanallahil 'adzim (Mahasuci Allah dengan segala puji-Nya - Mahasuci Allah Yang Maha Agung)", key: "subhanAllah" },
    { title: "La ilaha illallah wahdahu la sharika lah, lahul mulku wa lahul hamdu wa huwa 'ala kulli shay'in qadir (Tiada Tuhan selain Allah, Yang Maha Esa, tidak ada sekutu bagi-Nya, bagi-Nya kerajaan dan pujian, dan Dia Maha Kuasa atas segala sesuatu)", key: "laIlahaIllallah2" },
    { title: "Subhanallah - Alhamdulillah - La ilaha illallah - Allahu Akbar (Mahasuci Allah - Segala puji bagi Allah - Tiada Tuhan selain Allah - Allah Maha Besar)", key: "combined" },
  ];
  const allTasbeehat = [...defaultTasbeehat, ...state.customTasbeehat];
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>
              Kalkulator Istighfar - Tasbih Elektronik
            </h1>
          </div>
          <div className="border border-light shadow-lg p-4 rounded" style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "10px",
            boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
          }}>
            <div className="row">
              <div>
                <p>
                  Penghitung istighfar atau penghitung tasbih dan istighfar adalah alat elektronik
                  yang membantu Anda menghitung jumlah tasbih dan istighfar. Penghitung digital ini
                  dapat digunakan dengan mudah dengan menekan lingkaran untuk mencatat setiap
                  tasbih, dan Anda juga dapat mereset penghitung dengan menekan tombol reset.{" "}
                  <b>
                    Penghitung Anda disimpan secara otomatis meskipun Anda menyegarkan atau menutup halaman,
                    sehingga Anda dapat melanjutkan dari tempat Anda berhenti.
                  </b>{" "}
                  Alat ini sangat ideal untuk memudahkan proses dzikir dan meningkatkan konsentrasi
                  saat beribadah.
                  Anda juga dapat menggunakan penghitung ini untuk menentukan target tertentu untuk tasbih. Alat ini juga dilengkapi dengan suara peringatan saat mencapai target yang ditentukan.
                </p>
                <b>Beberapa dzikir yang dapat Anda gunakan dengan penghitung:</b>
                <ul>
                  {defaultTasbeehat.map(item => (
                    <li key={item.key}>{item.title}</li>
                  ))}
                </ul>
                <p>
                  Anda juga dapat menambahkan dzikir khusus Anda sendiri melalui tombol "Tambah dzikir" di bawah.
                </p>
                <div className=" my-3">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(true)}
                  >
                    Tambah dzikir
                  </button>
                </div>
              </div>
              <div className="alert-info text-center p-3 rounded" style={{ fontSize: "16px" }}>
                Anda juga dapat mengunjungi <a href="/calculator/id/athkar-alsabah/" className="text-decoration-none "><strong>Penghitung Dzikir Pagi</strong></a> dan juga <a href="/calculator/id/athkar-almasaa/" className="text-decoration-none fw-bold"><strong>Penghitung Dzikir Sore</strong></a>
              </div>

            </div>
            <br />
            {allTasbeehat.map((item) => (
              <div className="row" key={item.key} style={{ paddingBottom: "15px" }}>
                <div className="col calculatorStyle">
                  <div className="p-3 mb-2 bg-success text-white text-center">
                    <h2 style={{ fontSize: "24px" }}>{item.title}</h2>
                    {state.customTasbeehat.some(t => t.key === item.key) && (
                      <button
                        className="text-white px-4 py-2 btn btn-secondary"
                        onClick={() => handleRemoveTasbeeh(item.key)}
                        style={{ float: "left", marginTop: "-35px", }}
                      >
                        Hapus
                      </button>
                    )}
                  </div>
                  <hr />
                  <div>
                    <div className="text-center my-4">
                      <div
                        style={{
                          background: "linear-gradient(135deg, #ffffff 0%, #e0f7fa 100%)",
                          color: "#4caf50",
                          borderRadius: "50%",
                          width: "300px",
                          height: "300px",
                          lineHeight: "300px",
                          fontSize: "70px",
                          fontWeight: "bold",
                          margin: "0 auto",
                          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                          cursor: "pointer",
                          userSelect: "none",
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center",
                        }}
                        onClick={() => handleIncrement(item.key)}
                      >
                        {state.counts[item.key] || 0}
                      </div>
                    </div>
                    <br />
                    <div className="text-center mt-2">
                      <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                        <button
                          className="text-white px-4 py-2"
                          style={{
                            background: "linear-gradient(135deg, #f44336 0%, #e57373 100%)",
                            borderRadius: "20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            border: "none",
                            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                            transition: "background 0.3s",
                            padding: "15px",
                          }}
                          onClick={() => handleDecrement(item.key)}
                        >
                          Kurangi
                        </button>
                        <button
                          className="text-white px-4 py-2"
                          style={{
                            background: "linear-gradient(135deg, #2196f3 0%, #64b5f6 100%)",
                            borderRadius: "20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            border: "none",
                            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                            transition: "background 0.3s",
                            padding: "15px",
                          }}
                          onClick={() => handleReset(item.key)}
                        >
                          Reset
                        </button>
                        <button
                          className="text-white px-4 py-2"
                          style={{
                            background: "linear-gradient(135deg, #4caf50 0%, #81c784 100%)",
                            borderRadius: "20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            border: "none",
                            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                            transition: "background 0.3s",
                            padding: "15px",
                          }}
                          onClick={() => handleSetGoal(item.key)}
                        >
                          Tentukan Target
                        </button>
                      </div>
                      {state.goals[item.key] && (
                        <div className="mt-2" style={{ fontSize: "16px", color: "#4caf50" }}>
                          <hr />
                          Target:
                          {state.goals[item.key]} - Sisa: {Math.max(state.goals[item.key] - (state.counts[item.key] || 0), 0)}
                          <br />
                          <button
                            className="text-white px-2 py-1 ms-2"
                            style={{
                              background: "linear-gradient(135deg, #ff9800 0%, #ffb74d 100%)",
                              borderRadius: "15px",
                              fontSize: "18px",
                              fontWeight: "bold",
                              border: "none",
                              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                              transition: "background 0.3s",
                              marginTop: "10px",
                            }}
                            onClick={() => handleRemoveGoal(item.key)}
                          >
                            Hapus Target
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <Dialog open={showModal} onClose={() => setShowModal(false)}>
        <DialogTitle>Tambah Dzikir Baru</DialogTitle>
        <DialogContent>
          <Box sx={{ minWidth: 300, padding: 2 }}>
            <TextField
              autoFocus
              margin="dense"
              id="tasbeeh-text"
              label="Teks Dzikir"
              type="text"
              fullWidth
              variant="outlined"
              value={newTasbeeh}
              onChange={(e) => setNewTasbeeh(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowModal(false)} color="secondary">
            Batal
          </Button>
          <Button onClick={handleAddTasbeeh} color="primary" variant="contained">
            Simpan
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={showGoalModal} onClose={() => setShowGoalModal(false)}>
        <DialogTitle>Tentukan Target Dzikir</DialogTitle>
        <DialogContent>
          <Box sx={{ minWidth: 300, padding: 2 }}>
            <TextField
              autoFocus
              margin="dense"
              id="goal-value"
              label="Jumlah Tasbih yang Diinginkan"
              type="number"
              fullWidth
              variant="outlined"
              value={goalValue}
              onChange={(e) => setGoalValue(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          {state.goals[currentGoalTasbeeh] && (
            <Button
              onClick={() => {
                handleRemoveGoal(currentGoalTasbeeh);
                setShowGoalModal(false);
              }}
              color="error"
            >
              Hapus Target
            </Button>
          )}
          <Button onClick={() => setShowGoalModal(false)} color="secondary">
            Batal
          </Button>
          <Button onClick={handleSaveGoal} color="primary" variant="contained">
            Simpan
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default TallyCounter;